import { render } from "./Feature.vue?vue&type=template&id=1357f9b9&scoped=true"
import script from "./Feature.vue?vue&type=script&lang=js"
export * from "./Feature.vue?vue&type=script&lang=js"

import "./Feature.vue?vue&type=style&index=0&id=1357f9b9&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1357f9b9"]])

export default __exports__